export interface CommandColumnActionItem {
    text: string;
    action: 'copy' | 'delete' | 'edit';
    disabled: boolean;
}